export default "__VITE_ASSET__B0PYP$va__"